<template>
  <div class="appBody min-vh-100 bg-grey-light">
    <course-top type="cadv" :currentItem="course"
                class="course-main-top"></course-top>
    <div v-if="course.detail" class="course-detail mt-2 course-tab px-3 py-2r bg-white color-33"
         v-html="detail">
    </div>
    <no-data v-else text="暂无详情信息"></no-data>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import CourseTop from '@/components/courseTop'
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import noData from '@/components/noData';
  export default {
    name: "courseDetail",
    data() {
      return {
        course: {},
        detail: '',
        showShare: false,
        shareObj: {},
      }
    },
    components: {
      CourseTop,
      littleFooter,
      noData,
    },
    mounted() {
      this.courseId = this.$route.params['id'];
      this.proId = this.$route.query['proId'];
      this.getCourse();
      if (this.proId) {
        this.getProjectCourse();
      } else {
        this.getCourse();
      }
    },
    methods: {
      getContent() {
        if (this.course && this.course.detail) {
          this.$store.dispatch('getContent', {content: this.course.detail}).then((res) => {
            this.detail = res;
          })
        }
      },

      getCourse() {
        this.$store.dispatch('getCourseForLearner', {id: this.courseId}).then((res) => {
          this.course = res;
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.course.title
          });
          sessionStorage.setItem("currentCourse", JSON.stringify(this.course));
          this.getContent();
        })
      },
      getProjectCourse() {
        this.$store.dispatch('getProjectCourseForLearner', {id: this.courseId, proId: this.proId}).then((res) => {
          if(res && res.course) {
            this.course = res.course;
          }
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.course.title
          });
          sessionStorage.setItem("currentCourse", JSON.stringify(this.course));
          this.getContent();
        })
      }

    }
  }
</script>

<style scoped>

</style>
